import React from 'react';
import { BrainCircuit } from 'lucide-react';
import { PetProfile } from '../../types';
import { useTranslation } from '../../hooks/useTranslation';

interface AIAdvisorProps {
  profile: PetProfile;
  onOpenAI: () => void;
}

export const AIAdvisor: React.FC<AIAdvisorProps> = ({
  profile,
  onOpenAI
}) => {
  const { t } = useTranslation();

  return (
    <div className={`p-6 rounded-[2.5rem] text-white shadow-xl relative overflow-hidden ${profile.type === 'chat' ? 'bg-orange-600' : 'bg-indigo-900'}`}>
      <div className="relative z-10">
        <h4 className="font-bold text-lg mb-1">
          {t('app:dashboard.ai_advisor', { 
            type: profile.type === 'chat' ? t('app:pet.feline') : t('app:pet.canine') 
          })}
        </h4>
        <p className="text-white/70 text-xs mb-4">
          {t('app:dashboard.ai_question', { name: profile.name })}
        </p>
        <button 
          onClick={onOpenAI}
          className={`bg-white px-6 py-2.5 rounded-xl font-bold text-sm ${
            profile.type === 'chat' ? 'text-orange-600' : 'text-indigo-900'
          }`}
        >
          {t('common:buttons.chat')}
        </button>
      </div>
      <BrainCircuit className="absolute -right-4 -bottom-4 text-white/10 w-32 h-32" />
    </div>
  );
};
